import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles((theme) => ({
  ticket: {
    display: "flex",
    height: "105px",
    alignItems: "center",
    padding: theme.espacamento.spacing400,
    width: "100%",
    background: theme.palette.background100,
    "&.Mui-selected": {
      backgroundColor: theme.palette.background300,
    },
    [theme.breakpoints.down("xs")]: {
      minHeight: "105px",
      height: "auto",
      alignItems: "stretch",
      padding: "12px 8px 12px 16px",
      gap: theme.espacamento.spacing300,
    },
  },
  avatar: {
    marginRight: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      minWidth: 64,
      marginRight: 0,
      flex: "0 0 64px",
      alignSelf: "center",
    },
  },
  content: {
    color: theme.palette.neutral400,
    width: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    gap: theme.spacing(0.25),
    [theme.breakpoints.down("xs")]: {
      flex: "1 1 auto",
      minWidth: 0,
      whiteSpace: "normal",
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  name: {
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "17.5px",
    letterSpacing: "-0.25%",
    color: theme.palette.neutral400,
    height: "18px",
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      height: "auto",
      minHeight: "18px",
      minWidth: 0,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  },
  messageRow: {
    display: "flex",
    alignItems: "center",
    minWidth: 0,
  },
  description: {
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "15px",
    letterSpacing: "-0.25%",
    color: theme.palette.neutral400,
    height: "15px",
    display: "flex",
    alignItems: "center",
    marginTop: "2px",
    gap: "2px",
    [theme.breakpoints.down("xs")]: {
      height: "auto",
      minHeight: "15px",
      minWidth: 0,
      overflow: "hidden",
      "& > *": {
        minWidth: 0,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      },
    },
  },
  responsavel: {
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "15px",
    letterSpacing: "-0.25%",
    height: "15px",
    display: "flex",
    alignItems: "center",
    marginTop: "2px",
    gap: "2px",
    color: theme.palette.neutral400,
  },
  situacoes: {
    display: "flex",
    marginTop: "2px",
    gap: "2px",
    [theme.breakpoints.down("xs")]: {
      gap: "4px",
      flexWrap: "wrap",
      overflow: "hidden",
      "& .MuiChip-root": {
        maxWidth: "100%",
      },
      "& .MuiChip-label": {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        paddingLeft: 8,
        paddingRight: 8,
      },
    },
  },
  chipIcon: {
    fontSize: "12px !important",
    width: "12px !important",
    height: "12px !important",
    marginLeft: "6px",
    marginRight: "-4px",
    color: "#969696",
    [theme.breakpoints.down("xs")]: {
      marginRight: "4px",
    },
  },
  time: {
    color: theme.palette.text.secondary,
  },
  iconOptions: {
    color: theme.palette.neutral400,
  },
  noTicketsDiv: {
    display: "flex",
    height: "100px",
    margin: 40,
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  newMessagesCount: {
    position: "absolute",
    alignSelf: "center",
    marginRight: 8,
    marginLeft: "auto",
    top: "10px",
    left: "20px",
    borderRadius: 0,
  },
  noTicketsText: {
    textAlign: "center",
    color: "rgb(104, 121, 146)",
    fontSize: "14px",
    lineHeight: "1.4",
  },
  noTicketsTitle: {
    textAlign: "center",
    fontSize: "16px",
    fontWeight: "600",
    margin: "0px",
  },
  menuActions: {
    backgroundColor: theme.palette.neutral, // Define a cor de fundo aqui
    borderRadius: "12px",
    boxShadow: "0 4px 4pxrgba(0, 0, 0, 0.2)",
    width: "236px",
    border: `1px solid ${theme.palette.neutral200}`,
  },
  menu: {
    padding: "8px 8px",
    flexDirection: "column",
    alignItems: "flex-start",
    alignSelf: "stretch",
    borderRadius: "12px",
  },
  iconMenu: {
    strokeWidth: "1.6",
    size: "24px",
    color: theme.palette.neutral400,
  },
  textMenuPerfil: {
    color: theme.palette.neutral400,
    fontFeatureSettings: "'liga' off, 'clig' off",
    fontFamily: "Roboto",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "125%",
    letterSpacing: "-0.04px",
    paddingLeft: "16px",
    paddingTop: "12px",
    paddingBottom: "12px",
  },
  menuItem: {
    borderRadius: "12px",
  },
  iconeBotao: {
    [theme.breakpoints.down("xs")]: {
      flex: "0 0 44px",
      alignSelf: "center",
      marginLeft: "auto",
    },
    "&.MuiButtonBase-root.MuiIconButton-root": {
      color: theme.palette.neutral400,
      borderRadius: theme.radius.radius300,
      padding: theme.espacamento.spacing300,
      gap: theme.espacamento.spacing300,
      [theme.breakpoints.down("xs")]: {
        minWidth: 44,
        minHeight: 44,
      },
    },
  },
}))

export default useStyles
